import React, { useState } from "react";
import { Slider, Handles, Tracks, Rail } from "react-compound-slider";
import { Handle, SliderRail, Track } from "../../../components/RangeSlider";
import { updateSetting, useSettings } from "../../../redux/settings";
import {
  chooseGame,
  showCustomGamePopup,
  useLobby,
} from "../../../redux/lobby";
import styles from "./CustomGamePopup.module.css";
import Popup from "../../../components/Popup";
import useTranslation from "next-translate/useTranslation";
import {
  ModeIds,
  VARIANT_CHESS,
  TimeControl,
  DAILY_TAB,
} from "@chesshotel/constants";
import { getModeId } from "../../../util/util";
// import SegmentedControl from "../../../components/SegmentedControl";
import LiveOptions from "../../../components/LiveOptions";
import DailyOptions from "../../../components/DailyOptions";
import SegmentedControl from "@/components/SegmentedControl";
import DailyNotMember from "../daily/DailyNotMember";
import { useUser } from "@/redux/user";
import { saveAndChooseGame } from "../../shared/saveAndChooseGame";
// import { createQuickMatch } from "../CreateGame";
// import { createChallenge } from "../../shared/challengeController";
// import { useDaily } from "../../../ducks/daily";
// import { useUser } from "../../../ducks/user";

// export const GAME_MODE_LIVE = 0;
// export const GAME_MODE_DAILY = 1;

export default function CustomGamePopup() {
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");

  const { minOpponentRating, maxOpponentRating } = useSettings();
  const { time, inc, variant, timeControl, turnLength } = useLobby();
  const { isGuest } = useUser();

  const [chosenTime, setChosenTime] = useState(time);
  const [chosenInc, setChosenInc] = useState(inc);
  const [chosenVariant, setChosenVariant] = useState(variant);
  const [chosenTimeControl, setTimeControl] = useState(timeControl);
  const [chosenTurnLength, setTurnLength] = useState(turnLength);

  const [showDailyPopup, setShowDailyPopup] = useState(false);

  // const [minRating, setMinRating] = useState(minOpponentRating);
  // const [maxRating, setMaxRating] = useState(maxOpponentRating);

  // const handleSliderUpdate = (values) => {
  //   setMinRating(values[0]);
  //   setMaxRating(values[1]);
  // };

  // const handleSliderChange = (values) => {
  //   updateSetting("minOpponentRating", values[0]);
  //   updateSetting("maxOpponentRating", values[1]);
  // };

  const handleCreateChallenge = () => {
    saveAndChooseGame(
      chosenTime,
      chosenInc,
      chosenVariant,
      chosenTurnLength,
      chosenTimeControl
    );
    // const modeId = getModeId(chosenTime, chosenVariant, timeControl);

    // chooseGame({
    //   time: chosenTime,
    //   inc: chosenInc,
    //   variant: chosenVariant,
    //   modeId,
    //   turnLength,
    //   timeControl,
    // });

    // try {
    //   localStorage.setItem("customTime", chosenTime.toString());
    //   localStorage.setItem("customInc", chosenInc.toString());
    //   localStorage.setItem("customVariant", chosenVariant.toString());

    //   localStorage.setItem("chosenTime", chosenTime.toString());
    //   localStorage.setItem("chosenInc", chosenInc.toString());
    //   localStorage.setItem("chosenVariant", chosenVariant.toString());
    // } catch (e) {}

    // setCustomGame({ time: chosenTime, inc: chosenInc, variant: chosenVariant });
    showCustomGamePopup(false);
  };

  const defaultValues = [minOpponentRating, maxOpponentRating];

  return (
    <Popup
      title={lobbyT("Custom")}
      top
      onClose={() => showCustomGamePopup(false)}
    >
      {showDailyPopup && (
        <Popup title={t("Daily")} top onClose={() => setShowDailyPopup(false)}>
          <DailyNotMember />
          <div className="flex items-center justify-end mt-8">
            <button
              className="btn btn-base btn-outline"
              onClick={() => setShowDailyPopup(false)}
            >
              {t("Cancel")}
            </button>
          </div>
        </Popup>
      )}

      <div className={styles.createGameCont}>
        <div className={styles.createGame}>
          <label className={styles.label}>{t("Variant")}</label>
          <SegmentedControl
            options={[t("Standard"), "Chess960"]}
            numbersAsOptions={true}
            startNumber={1}
            selected={chosenVariant}
            setSelected={setChosenVariant}
            selectedBgColor="bg-altblue-500"
            selectedTextColor="text-white"
            unselectedBgColor="bg-altgray-200"
            unselectedTextColor="text-altgray-700"
            customClassNameOuterDiv="border-4 border-altgray-200 bg-altgray-200 rounded-md"
            customClassNameInnerDiv="p-1 rounded-md shadow-xl no-select"
          />
          <div className="mt-5">
            <label className={styles.label}>{t("Time control")}</label>
            <SegmentedControl
              options={[t("Live"), t("Daily")]}
              numbersAsOptions={true}
              startNumber={1}
              selected={chosenTimeControl}
              setSelected={(val) => {
                if (isGuest && val == TimeControl.DAILY) {
                  setShowDailyPopup(true);
                } else {
                  setTimeControl(val);
                }
              }}
              selectedBgColor="bg-altblue-500"
              selectedTextColor="text-white"
              unselectedBgColor="bg-altgray-200"
              unselectedTextColor="text-altgray-700"
              customClassNameOuterDiv="border-4 border-altgray-200 bg-altgray-200 rounded-md"
              customClassNameInnerDiv="p-1 rounded-md shadow-xl no-select"
            />
          </div>
          {chosenTimeControl === TimeControl.LIVE && (
            <LiveOptions
              setTime={setChosenTime}
              time={chosenTime}
              setInc={setChosenInc}
              inc={chosenInc}
              styles={styles}
            />
          )}

          {chosenTimeControl === TimeControl.DAILY && (
            <DailyOptions
              turnLength={chosenTurnLength}
              setTurnLength={setTurnLength}
              styles={styles}
            />
          )}

          {/* <label
            className="text-sm mt-4 mb-0.5"
            style={{ marginBottom: "10px" }}
          >
            {t("Opponent rating")}:
            <span
              style={{ fontWeight: "bolder" }}
            >{` ${minRating} - ${maxRating}`}</span>
          </label>
          <Slider
            step={10}
            mode={5}
            domain={[0, 3000]}
            rootStyle={{
              position: "relative",
              marginLeft: "12px",
              marginRight: "12px",
              marginTop: "12px",
              marginBottom: "22px",
            }}
            onUpdate={handleSliderUpdate}
            onChange={handleSliderChange}
            values={defaultValues}
          >
            <Rail>
              {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
            </Rail>
            <Handles>
              {({ handles, getHandleProps }) => (
                <div className="slider-handles">
                  {handles.map((handle, i) => (
                    <Handle
                      key={handle.id}
                      handle={handle}
                      domain={[0, 3000]}
                      getHandleProps={getHandleProps}
                    />
                  ))}
                </div>
              )}
            </Handles>
            <Tracks left={false} right={false}>
              {({ tracks, getTrackProps }) => (
                <div className="slider-tracks">
                  {tracks.map(({ id, source, target }) => (
                    <Track
                      key={id}
                      source={source}
                      target={target}
                      getTrackProps={getTrackProps}
                    />
                  ))}
                </div>
              )}
            </Tracks>
          </Slider> */}
          <div className="flex justify-end items-center w-full mt-6 pt-4">
            <button
              className="btn btn-base btn-outline"
              onClick={() => showCustomGamePopup(false)}
            >
              {t("Cancel")}
            </button>
            <button
              className="btn btn-base btn-blue ml-3"
              onClick={handleCreateChallenge}
            >
              {t("Done")}
            </button>
          </div>
        </div>
      </div>
    </Popup>
  );
}
